<template>
  <div>
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppButtonList
        :theme="theme"
        :buttons="buttons"
        :value="incomeFrequency"
        @input="$_buttonList_handleInput(buttonListActionName, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="$_loans_updateLead(updateLeadPayload, $_buttonList_dataLayerObject)"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import buttonList from '@/mixins/button-list'
import submitLoans from '@/mixins/submit/submit-loans'

export default {
  // Name
  name: 'IncomeDetailsFrequency',

  // Components
  components: {
    AppButton,
    AppButtonList,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [
    submitLoans,
    buttonList,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'Income Details\nPlease Select One:'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Data
  data () {
    return {
      buttonListActionName: 'setIncomeFrequency',
      buttonListFieldName: 'incomeFrequency',
      buttons: [{
        text: 'I Know My Annual Salary',
        value: 'Annual',
        dataLayer: 'income_annual_salary'
      }, {
        text: 'I Know My Hourly Wage',
        value: 'Hourly',
        dataLayer: 'income_hourly_wage'
      }, {
        text: 'I Know My Monthly Income',
        value: 'Monthly',
        dataLayer: 'income_monthly_income'
      }, {
        text: 'Other',
        value: 'Other',
        dataLayer: 'income_other'
      }],
      buttonListDataLayerStepName: `spring_${this.eventPrefix}_income_details`
    }
  },

  computed: {
    incomeFrequency () {
      return this.$store.state.employment.income_frequency
    },

    updateLeadPayload () {
      return { income_frequency: this.incomeFrequency }
    }
  },

  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.$_loans_updateLead(this.updateLeadPayload, this.$_buttonList_dataLayerObject)
      this.$store.dispatch('setTriggerContinue', false)
    },

    incomeFrequency () {
      this.$store.dispatch('resetIncome')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
